/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import {

  Card, CardBody, Col, Container, Row, Table,
} from 'reactstrap';
import { RTLProps } from '@/shared/prop-types/ReducerProps';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useParams } from 'react-router';


const Shipments = ({ rtl }) => {
  const [cookies] = useCookies(['tranAuthToken']);


  const { id } = useParams();

  const
    {
      data,
      isLoading,
      isFetching,
      isError,
    } = useQuery('todos', () => axios.get(`https://orca-app-5i5qx.ondigitalocean.app/api/admin/shipments/${id}`, {
      headers: {
        Authorization: `Bearer ${cookies.tranAuthToken}`,
      },
    }));
  if (data && !isLoading && !isFetching && !isError) {
    console.log('all shipments', data.data);
  }



  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">All Shipments</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">All Shipments Table</h5>
              </div>
              <Table responsive hover className="table--bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Consignor</th>
                    <th>Consignor Email</th>
                    <th>Time</th>
                    <th>Tracking Status</th>
                    <th>Transporter</th>
                    <th>Transporter Email</th>
                  </tr>
                </thead>
                <tbody>
                  {isFetching && <tr><td>Loading...</td></tr>}
                  {!isLoading && !isFetching && !isError && data && data.data && data.data.map((item, index) => (
                    <tr key={item._id}>
                      <td>{item._id}</td>
                      <td>{item.consignor}</td>
                      <td>{item.consignorEmail}</td>
                      <td>{new Date(item.timestamp).toLocaleDateString()}</td>
                      <td>{item.tracking_status}</td>
                      <td>{item.transporter}</td>
                      <td>{item.transporterEmail}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

Shipments.propTypes = {
  rtl: RTLProps.isRequired,
};

export default connect(state => ({
  rtl: state.rtl,
}))(Shipments);
